import React from 'react';
import PropTypes from 'prop-types';
import { observer } from 'mobx-react';
import { withNamespaces } from 'react-i18next';

import Paragraph from 'components/Paragraph';
import BaseCard from 'apps/notificationCenter/views/baseCard';

import { StyledLink } from 'legacyComponents/styled/lib';
import {
  ButtonStyled,
  ContentRowWrapper,
} from 'apps/notificationCenter/styles';

const InviteCard = props => {
  const { t, notification } = props;
  const { targetApp } = notification;
  const { status, groupSpaceType, groupTitle } = targetApp;
  if (!notification || !targetApp) return null;

  const spaceTypeName = {
    INITIATIVE: t('Organisation'),
    PROJECT: t('Project'),
    SHARED_FILE: t('Shared File'),
  };

  const spaceTypeAcceptedAction = {
    INITIATIVE: t('View Organisation'),
    PROJECT: t('View Project'),
    SHARED_FILE: t('View File'),
  };

  const message = (
    <Paragraph>
      {t('Invited you to')}{' '}
      {groupSpaceType === 'SHARED_FILE' ? '' : ' join the'}{' '}
      {groupSpaceType !== 'SHARED_FILE'
        ? `${spaceTypeName[groupSpaceType]} ` || 'space'
        : ''}
      {groupSpaceType === 'SHARED_FILE' ? (
        <strong>{groupTitle}</strong>
      ) : (
        <strong>
          <StyledLink {...targetApp.route}>{groupTitle}</StyledLink>
        </strong>
      )}
      {status === 'APPROVED' ? (
        <> {t('and you accepted.')}</>
      ) : status === 'REJECTED' ? (
        <> {t('and you rejected.')}</>
      ) : (
        <>{'.'}</>
      )}
    </Paragraph>
  );

  return (
    <BaseCard notification={notification} message={message} isActionable>
      {status === 'PENDING' && (
        <ContentRowWrapper>
          <ButtonStyled
            icon='check'
            iconPosition='left'
            size='xsmall'
            appearance='plain'
            text={t('Accept Invite')}
            data-testid='notification-accept-button'
            onClick={() => targetApp.Accept()}
          />
          <ButtonStyled
            icon='close'
            iconPosition='left'
            size='xsmall'
            appearance='plain'
            variant='minimal'
            text={t('Reject Invite')}
            onClick={() => targetApp.Reject()}
          />
        </ContentRowWrapper>
      )}

      {status === 'APPROVED' && groupSpaceType === 'SHARED_FILE' && (
        <ContentRowWrapper>
          <StyledLink {...targetApp.route}>
            <ButtonStyled
              icon='view'
              iconPosition='left'
              size='xsmall'
              appearance='plain'
              text={spaceTypeAcceptedAction[groupSpaceType]}
            />
          </StyledLink>
        </ContentRowWrapper>
      )}
    </BaseCard>
  );
};

InviteCard.propTypes = {
  t: PropTypes.func,
  notification: PropTypes.object,
  visible: PropTypes.bool,
};

export default withNamespaces()(observer(InviteCard));
